/* ----------------------------------------------------------------------------- 

  AnyPicker - Customizable Picker for Mobile OS
  Version 2.0.9
  Copyright (c)2017 Lajpat Shah
  Contributors : https://github.com/nehakadam/AnyPicker/contributors
  Repository : https://github.com/nehakadam/AnyPicker
  Homepage : https://nehakadam.github.io/AnyPicker

 ----------------------------------------------------------------------------- */

/*
	
	language: Austrian German ("de-at")
	file: AnyPicker-i18n-de-at

*/

(function ($) {
    $.AnyPicker.i18n["de-at"] = $.extend($.AnyPicker.i18n["de-at"], {

    	// Common

    	headerTitle: "Auswählen",
		setButton: "einstellen",
		clearButton: "klar",
		nowButton: "jetzt",
		cancelButton: "Abbrechen",
		dateSwitch: "Datum",
		timeSwitch: "Zeit",

    	// DateTime

    	veryShortDays: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
		shortDays: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
		fullDays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
		shortMonths: 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
		fullMonths: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
		numbers: '0_1_2_3_4_5_6_7_8_9'.split('_'),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		}
	
    });

})(jQuery);




/*
	
	language: German ("de")
	file: AnyPicker-i18n-de

*/

(function ($) {
    $.AnyPicker.i18n["de"] = $.extend($.AnyPicker.i18n["de"], {

    	// Common

    	headerTitle: "Auswählen",
		setButton: "einstellen",
		clearButton: "klar",
		nowButton: "jetzt",
		cancelButton: "Abbrechen",
		dateSwitch: "Datum",
		timeSwitch: "Zeit",

    	// DateTime

    	veryShortDays: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
		shortDays: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
		fullDays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
		shortMonths: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
		fullMonths: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
		numbers: '0_1_2_3_4_5_6_7_8_9'.split('_'),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		}
	
    });

})(jQuery);




/*

	language: English
	file: AnyPicker-i18n-en

*/

(function ($) {
    $.AnyPicker.i18n["en"] = $.extend($.AnyPicker.i18n["en"], {

    	// Common

    	headerTitle: "Select",
		setButton: "Set",
		clearButton: "Clear",
		nowButton: "Now",
		cancelButton: "Cancel",
		dateSwitch: "Date",
		timeSwitch: "Time",

    	// DateTime

        veryShortDays: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
		shortDays: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
		fullDays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
		shortMonths: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
		fullMonths: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
		numbers: "0_1_2_3_4_5_6_7_8_9".split("_"),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		},
		componentLabels: {
			date: "Date",
			day: "Day",
			month: "Month",
			year: "Year",
			hours: "Hours",
			minutes: "Minutes",
			seconds: "Seconds",
			meridiem: "Meridiem"
		}
	
    });

})(jQuery);



/*

	language: French
	file: AnyPicker-i18n-fr

*/

(function ($) {
    $.AnyPicker.i18n["fr"] = $.extend($.AnyPicker.i18n["fr"], {

    	// Common

    	headerTitle: "Sélectionner",
		setButton: "Set",
		clearButton: "Clair",
		nowButton: "Maintenant",
		cancelButton: "Annuler",
		dateSwitch: "Date",
		timeSwitch: "Temps",

    	// DateTime

    	veryShortDays: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
		shortDays: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
		fullDays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
		shortMonths: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
		fullMonths: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
		numbers: '0_1_2_3_4_5_6_7_8_9'.split('_'),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		}
	
    });

})(jQuery);




/*

	language: Norwegian Bokmål
	file: AnyPicker-i18n-nb
	author: Tommy Eliassen(https://github.com/pusle)

*/

(function ($) {
    $.AnyPicker.i18n["nb"] = $.extend($.AnyPicker.i18n["nb"], {

    	// Common

    	headerTitle: "Velg",
		setButton: "Bruk",
		clearButton: "Tøm",
		nowButton: "Nå",
		cancelButton: "Avbryt",
		dateSwitch: "Dato",
		timeSwitch: "Klokkeslett",

    	// DateTime

        veryShortDays: "Sø_Ma_Ti_On_To_Fr_Lø".split("_"),
		shortDays: "Søn_Man_Tir_Ons_Tor_Fre_Lør".split("_"),
		fullDays: "Søndag_Mandag_Tirsdag_Onsdag_Torsdag_Fredag_Lørdag".split("_"),
		shortMonths: "Jan_Feb_Mar_Apr_Mai_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
		fullMonths: "Januar_Februar_Mars_April_Mai_Juni_Juli_August_September_Oktober_November_Desember".split("_"),
		numbers: "0_1_2_3_4_5_6_7_8_9".split("_"),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		}
	
    });

})(jQuery);




/*

	language: Russian
	file: AnyPicker-i18n-ru

*/

(function ($) {
    $.AnyPicker.i18n["ru"] = $.extend($.AnyPicker.i18n["ru"], {

    	// Common

    	headerTitle: "выбрать",
		setButton: "Установите",
		clearButton: "Очистить",
		nowButton: "сейчас",
		cancelButton: "отменить",
		dateSwitch: "дата",
		timeSwitch: "время",

    	// DateTime

    	veryShortDays: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
		shortDays: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
		fullDays: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
		shortMonths: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
		fullMonths: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
		numbers: '0_1_2_3_4_5_6_7_8_9'.split('_'),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		}
	
    });

})(jQuery);




/*

	language: Chinese
	file: AnyPicker-i18n-zh-cn

*/

(function ($) {
    $.AnyPicker.i18n["zh-cn"] = $.extend($.AnyPicker.i18n["zh-cn"], {

    	// Common

    	headerTitle: "选择",
		setButton: "设置",
		clearButton: "明确",
		nowButton: "现在",
		cancelButton: "取消",
		dateSwitch: "日期",
		timeSwitch: "时间",

    	// DateTime

    	veryShortDays: '日_一_二_三_四_五_六'.split('_'),
		shortDays: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
		fullDays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
		shortMonths: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
		fullMonths: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
		numbers: '0_1_2_3_4_5_6_7_8_9'.split('_'),
		meridiem: 
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		}
	
    });

})(jQuery);
